export { default } from './EzDrawer.vue';
